import { render, staticRenderFns } from "./PictureList.vue?vue&type=template&id=2b14f2a6&scoped=true&"
import script from "./PictureList.vue?vue&type=script&lang=js&"
export * from "./PictureList.vue?vue&type=script&lang=js&"
import style0 from "./PictureList.vue?vue&type=style&index=0&id=2b14f2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14f2a6",
  null
  
)

export default component.exports